import { useState } from 'react';

import { UseStoreChangeDialogProps } from '../../types';

export const useStoreChangeDialog = (onNavigate: () => void): UseStoreChangeDialogProps => {
  const [showDialog, setShowDialog] = useState(false);

  const handleDismiss = () => {
    setShowDialog(false);
  };

  const handleConfirm = () => {
    setShowDialog(false);
    onNavigate();
  };

  const openDialog = () => {
    setShowDialog(true);
  };

  return {
    showDialog,
    openDialog,
    onDismiss: handleDismiss,
    onConfirm: handleConfirm,
  };
};
